module.exports = __webpack_public_path__ + "static/media/AboutPage__Emanuel.852e3d2f.png";